"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEXT_DAY_TEXT = exports.PUNCHES_OVERVIEW_TEST_ID = void 0;
exports.PUNCHES_OVERVIEW_TEST_ID = 'punches-overview';
exports.NEXT_DAY_TEXT = '+1';
